// Google Analytics utilities

const GA_TRACKING_ID = 'G-4SNJNXT7SR';

// Check if user has consented to analytics cookies
export const hasAnalyticsConsent = () => {
  try {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) return false;

    const preferences = JSON.parse(consent);
    return preferences.analytics === true;
  } catch (e) {
    console.error('Failed to check analytics consent:', e);
    return false;
  }
};

// Initialize Google Analytics
export const initializeGA = () => {
  if (!hasAnalyticsConsent()) {
    console.log('Google Analytics not loaded: User has not consented');
    return;
  }

  // If the user previously opted out in this session, re-enable GA for this page.
  // (We used to rely on full page reloads after consent changes, so this flag
  // would naturally reset. Now we apply consent changes without reload.)
  window[`ga-disable-${GA_TRACKING_ID}`] = false;

  // Check if already loaded
  if (window.gtag) {
    console.log('Google Analytics already initialized');
    return;
  }

  // Load gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  document.head.appendChild(script);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_TRACKING_ID, {
    anonymize_ip: true, // Anonymize IP for privacy compliance
    cookie_flags: 'SameSite=None;Secure',
  });

  console.log('Google Analytics initialized with user consent');
};

// Disable Google Analytics
export const disableGA = () => {
  // Set the gtag opt-out flag
  window[`ga-disable-${GA_TRACKING_ID}`] = true;

  // Clear GA cookies
  const gaCookies = ['_ga', '_gat', '_gid'];
  gaCookies.forEach(cookieName => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
  });

  console.log('Google Analytics disabled and cookies cleared');
};

// Track page view (only if consent given)
export const trackPageView = (page) => {
  if (hasAnalyticsConsent() && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: page,
    });
  }
};

// Track custom event (only if consent given)
export const trackEvent = (eventName, eventParams = {}) => {
  if (hasAnalyticsConsent() && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};
